import Image, { StaticImageData } from "next/image";
import React from "react";
import Link from "next/link";

interface ProductCardProps {
  href: string;
  image: StaticImageData;
  title: string;
}

const ProductCard: React.FC<ProductCardProps> = ({ href, image, title }) => {
  return (
    <Link
  href={href}
  className="group bg-white rounded-xl relative overflow-hidden duration-300 will-change-transform slick-fix"
>
  <div className="relative w-full h-full">
    <Image
      src={image}
      alt={title}
      loading="lazy"
      className="xl:h-[68vh] h-[55vh] w-full object-cover"
    />

    {/* Gradient + Title wrapper */}
    <div className="absolute inset-0 flex flex-col justify-end items-center text-center pointer-events-none">
      <div className="w-full h-1/2 bg-gradient-to-t from-black/80 to-transparent absolute bottom-0 left-0 z-0"></div>
      <h3 className="text-white text-2xl font-semibold z-10 mb-4">{title}</h3>
    </div>
  </div>
</Link>

  );
};

export default ProductCard;
